import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

import SeaServiceProfileForm from "./SeaServiceProfileForm";
import SeaServiceProfileDetails from "./SeaServiceProfileDetails";
import { CircularProgress, Box } from "@mui/material";
import baseURL from "../../config";


const SeaServiceProfileWrapper = () => {
    const { crewingAgentId } = useParams();
    const [profileData, setProfileData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editMode, setEditMode] = useState(false);

    const fetchProfile = async () => {
        try {
            // const vesselOwnerId = id;
            const token = localStorage.getItem("token");
            const res = await axios.get(`${baseURL}/api/getSeaServiceProfile/${crewingAgentId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const responseData = res.data?.data;
            // console.log(" res.data?.data;",  res.data?.data)

            // Even if response is 200, still check if it's really missing
            if (!responseData || res.data.message === "Sea Service Profile not found") {
                setProfileData(null);
            } else {
                setProfileData(responseData);
            }
        } catch (err) {
            console.error("Error fetching profile:", err.response?.data || err.message);

            if (err.response?.status === 404 || err.response?.data?.message === "Sea Service Profile not found") {
                setProfileData(null);
            } else {
                // Optional: Show a toast 
            }
        } finally {
            setLoading(false);
        }

    };

    useEffect(() => {
        fetchProfile();
    }, [crewingAgentId]);

    if (loading) {
        return (
            <Box sx={{ textAlign: "center", mt: 5 }}>
                <CircularProgress />
            </Box>
        );
    }

     if (editMode || !profileData) {
    return (
      <SeaServiceProfileForm
        initialData={profileData}
        onCancelEdit={() => setEditMode(false)}
        onProfileSaved={fetchProfile}
      />
    );
  }

   

    return profileData ? (
        <SeaServiceProfileDetails
         data={profileData} 
         onEditClick={() => setEditMode(true)}/>
    ) : (
        <SeaServiceProfileForm />
    );
};

export default SeaServiceProfileWrapper;
